import { useDigitalTrapsStore } from '@features/regional-overview/digital-traps/digital-traps.zustand';
import { generateDateColumnsAndKeys, groupAndTransformTraps } from '@features/regional-overview/digital-traps/utils';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

export const useObservedCountsData = () => {
  const [t] = useTranslation();
  const trapGroups = useDigitalTrapsStore(state => state.trapGroups);
  const isLoading = useDigitalTrapsStore(state => state.isLoading);
  const selectedDate = useDigitalTrapsStore(state => state.selectedDate);

  const networks = useMemo(() => {
    if (trapGroups.length === 0) {
      return [];
    }

    const { dateKeys } = generateDateColumnsAndKeys({ selectedDate, showTodayText: true, t });
    const processedTrapGroups = groupAndTransformTraps(trapGroups, dateKeys, t);

    return processedTrapGroups;
  }, [trapGroups, selectedDate, t]);

  return { networks, isLoading, anchorDate: selectedDate };
};
